import { Link } from 'react-router-dom';
import { liveSessions } from '@/mocks/lives';
import SectionHeading from '@/components/feature/SectionHeading';
import LiveCard from '@/components/feature/LiveCard';

export default function UpcomingSection() {
  const upcoming = liveSessions
    .filter((item) => item.status === 'upcoming')
    .sort((a, b) => a.start.localeCompare(b.start))
    .slice(0, 6);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="container-page">
        <SectionHeading
          eyebrow="即将开始场次"
          title="接下来要开的这几场，先设好提醒"
          desc="倒计时实时更新，点击「设提醒」把场次记进清单，重点场次我们还会提前发邮件通知。"
          action={
            <Link
              to="/schedule"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              查看全部场次
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </span>
            </Link>
          }
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {upcoming.map((session) => (
            <LiveCard key={session.id} session={session} />
          ))}
        </div>
      </div>
    </section>
  );
}